module.exports = __webpack_public_path__ + "img/desk1.9dca2ac1.png";